import { cn } from '../lib/utils'

type BrandStarProps = {
  className?: string
  tone?: 'red' | 'blue' | 'ink' | 'white' | 'soft'
}

const toneClasses: Record<NonNullable<BrandStarProps['tone']>, string> = {
  red: 'text-crusta-500',
  blue: 'text-crusta-800',
  ink: 'text-crusta-950',
  white: 'text-white',
  soft: 'text-crusta-300',
}

export function BrandStar({ className, tone = 'red' }: BrandStarProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 64 64"
      className={cn('shrink-0 fill-current', toneClasses[tone], className)}
    >
      <path d="M32 0C34.6 18.8 45.2 29.4 64 32C45.2 34.6 34.6 45.2 32 64C29.4 45.2 18.8 34.6 0 32C18.8 29.4 29.4 18.8 32 0Z" />
    </svg>
  )
}
